import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {Home} from '../pages/home';
import {StakingRoundPage} from '../pages/staking-round-page';
import {Faucet} from '../pages/faucet';
import {SaleRoundPage} from '../pages/sale-round-page';

export const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/staking-round/:stakingRoundId" element={<StakingRoundPage />} />
            <Route path="/sale-round/:saleRoundId" element={<SaleRoundPage />} />
            <Route path="/faucet" element={<Faucet />} />
        </Routes>
    );
};
